import _ from 'lodash';
import api from '../../api';
import worldMap from '../../core/map';
import environment from '../../environment';
import { StoreExportTypeEnum } from '../../../enuns/store.enun';
import { loading, unloading } from '../../shared';

const GetLayer = (name, currentMap = worldMap.getCurrent()) => {
    return require('../../layers/index').default.get(name, currentMap);
};

class ProtectAreaAction {
    constructor({ feature, layer, currentMap, name }) {
        const isAfterSales = environment.get('CONFIG.IS_AFTER_SALES');
        const isDealer = name === 'DealershipAfterSales';
        const isNetwork = name === 'NetworkAfterSales';
        const isStoresUnapproved = name === 'UnapprovedStores';

        const storeType = isNetwork
            ? StoreExportTypeEnum.Dealerships
            : StoreExportTypeEnum.Competitors;

        let protectAreaLayer = GetLayer('ProtectAreaUnapprovedStores');

        if (isAfterSales) {
            protectAreaLayer = isDealer
                ? GetLayer('ProtectAreaDealershipAfterSales')
                : isNetwork
                    ? GetLayer('ProtectAreaNetworkAfterSales')
                    : GetLayer('ProtectAreaCompetitorsAfterSales');
        }

        const turnOnProtectArea = () => {
            loading();
            protectAreaLayer.removeHide(feature.properties.Id);

            if (isAfterSales) {
                api.afterSales.get.protectArea(isDealer, storeType, feature.properties.Id).then((response) => {
                    const features = protectAreaLayer.getFeatures();
                    const data = {
                        features: _(response.features).concat(features).uniqBy('properties.Id').value(),
                        type: 'FeatureCollection'
                    };

                    protectAreaLayer.setFeatures(data, true);
                    unloading();
                });
            }

            if (isStoresUnapproved) {
                loading();
                protectAreaLayer.removeHide(feature.properties.Id);

                api.store.get.protectArea(feature.properties.Id).then((response) => {
                    const features = protectAreaLayer.getFeatures();
                    const data = {
                        features: _(response.features).concat(features).uniqBy('properties.Id').value(),
                        type: 'FeatureCollection'
                    };

                    protectAreaLayer.setFeatures(data, true);
                    unloading();
                });
            }
        };

        const turnOffProtectArea = () => {
            protectAreaLayer.setHide(feature.properties.Id);

            const features = {
                features: _(protectAreaLayer.getFeatures())
                    .filter(x => x.properties.StoreId !== feature.properties.Id)
                    .value(),
                type: 'FeatureCollection'
            };

            protectAreaLayer.setFeatures(features, true);
        };

        return {
            check: () => this._isSelected(feature, protectAreaLayer),
            layer,
            map: currentMap,
            icon: 'icon_bubble_tradearea',
            title: 'Protect Area',
            off: turnOffProtectArea,
            on: turnOnProtectArea
        };
    }

    _isSelected(feature, layer) {
        return !!_.find(layer.getFeatures(), f => f.properties.StoreId === feature.properties.Id);
    }
}

export default ProtectAreaAction;



// WEBPACK FOOTER //
// ./src/scripts/layers/HaloLayer/ProtectAreaAction.js